import TimelineActivity from '~/components/drawers/timeline/activity';

class TimelineActivityJobMatch extends TimelineActivity {}

TimelineActivityJobMatch.defaultProps = {
  title: (object) => {
    const { parameters: { name } = {} } = object.props.activity;
    return `Job Match Alert: duplicate contact has been successfully identified as ${name || 'Unknown'}`;
  },
  icon:         'briefcase',
  prefix:       'far',
  color:        'text-grey-dark',
  alwaysPublic: true,
};

export default TimelineActivityJobMatch;
